app.service('basketServices', function (console, loading, modal, broker, html, pageConfig, basketServicesWithExclusion, updateExcludedServices, basketAnalytics) {
	var selectedService, removeModal, counter = 0, savedAdded = {};
	var addedServicesWithExclusion = [];
	var $inputs, $confirm, $inputsAndSelects;
	var modalServicesInitialStateOnOpen;

	function count() {
		return counter;
	}

	function increase(productId, serviceId, quantity, productQuantity) {
		if (quantity < productQuantity) {
			update('add-single', {
				mainItemId: productId,
				serviceId: serviceId,
				addedFrom: 'CART_EDIT'
			});
		}
	}
	function decrease(productId, serviceId, quantity) {
		if (quantity > 1) {
			update('remove-single', {
				mainItemId: productId,
				serviceId: serviceId,
				addedFrom: 'CART_EDIT'
			});
		}
	}
	function remove(options) {
		basketAnalytics.removeService({
			productPlu: options.productPlu,
			servicePlu: options.servicePlu,
			quantity: options.quantity || 1
		});
		update('remove', {
			mainItemId: options.mainItemId,
			servicesIds: options.serviceId,
			addedFrom: 'CART_EDIT',
			noReload: options.noReload
		}, options.callback);
	}
	function add(options) {
		counter++;
		console.log('DODANIE USŁUGI - ' + options.serviceId + ' - DO PRODUKTU - ' + options.mainItemId);
		basketAnalytics.addService({
			productPlu: options.productPlu,
			servicePlu: options.servicePlu,
			details: 'services_one',
			quantity: options.quantity || 1
		});
		update('add', {
			mainItemId: options.mainItemId,
			servicesIds: options.serviceId,
			addedFrom: 'CART_EDIT',
			noReload: options.noReload,
		}, options.callback);
	}
	function removeFromModal(options) {
		counter--;
		console.log('USUWANIE USŁUGI - ' + options.serviceId + ' - DO PRODUKTU - ' + options.mainItemId);
		update('remove', {
			mainItemId: options.mainItemId,
			servicesIds: options.serviceId,
			addedFrom: 'CART_EDIT',
			noReload: options.noReload
		}, options.callback);
	}
	function update(action, options, callback) {
		modal.close(false);
		var url = '';
		if (action == 'add') {
			url = '/add-services-to-cart.ltr';
		} else if (action == 'add-single') {
			url = '/increase-services-quantity-in-cart.ltr';
		} else if (action == 'remove-single') {
			url = '/decrease-services-quantity-in-cart.ltr';
		} else if (action == 'remove') {
			url = '/remove-services-from-cart.ltr';
		} else if (action == 'change') {
			url = '/change-services-quantity-in-cart.ltr';
		}
		$.ajax({
			url: url,
			type: 'POST',
			data: options,
			cache: false,
			success: function () {
				if (!options.noReload) {
					document.location.reload();
				} else {
					if (callback) {
						callback();
					}
				}
			},
			error: function () {
				loading.stop();
				modal.alert('Błąd operacji na usługach. Prosimy spróbować później', function () {
					broker.trigger('REFRESH_BASKET_VIEW');
				})
			}
		});
	}
	function change(data) {
		update('change', data);
	}
	function info(serviceId, productId) {
		loading.start();
		$.ajax({
			url: '/service-front-view.ltr',
			data: {
				rwd: true,
				serviceId: serviceId,
				productId: productId
			},
			success: function (html) {
				loadSuccess(html);
			},
			error: function () {
				loadError();
			}
		});
	}
	function save() {
		loading.start();
		var added = [];
		var removed = [];
		var updated = [];
		var additionalToRemove = [];
		var focusParams = {
			main: savedAdded.mainItemId,
			group: savedAdded.group
		};
		$inputs.each(function () {
			const $this = $(this);
			const checked = $this.is(':checked');
			const value = $this.val();
			const plu = $this.data('plu');
			const mainItemId = $this.data('product');
			const productPlu = $this.data('product-plu');
			const excludedServicesGroupId = $this.data('excluded-services-group');
			const newQuantity = $this.parent().find('.js-service-quantity').val();
			const oldQuantity = addedQuantity(value, mainItemId);
			if (oldQuantity > 0 && !checked) {
				removed.push({ id: value, plu: plu, mainItemId: mainItemId, productPlu: productPlu, quantity: oldQuantity });
			} else if (newQuantity != oldQuantity && oldQuantity > 0 && checked) {
				updated.push({ id: value, quantity: newQuantity, plu: plu, mainItemId: mainItemId, productPlu: productPlu });
			} else if (newQuantity > oldQuantity && checked) {
				added.push({ id: value, quantity: newQuantity, plu: plu, mainItemId: mainItemId, productPlu: productPlu, excludedServicesGroupId: excludedServicesGroupId });
			}
		});
		// console.log('services added', added);
		// console.log('services removed', removed);
		// console.log('services updated', updated);
		// console.log('services addedWithExclusion', addedServicesWithExclusion);
		if (addedServicesWithExclusion.length && added.length) {
			additionalToRemove = [...basketServicesWithExclusion.getExcludedServicesForRemove(added, removed)];
			addedServicesWithExclusion = [];
		}
		function endSelected() {
			modal.close(false);
			broker.trigger('REFRESH_BASKET_VIEW', focusParams);
		}
		function addSelected() {
			var a = added.shift();
			console.log('adding service', a, savedAdded.paymentType);
			basketAnalytics.addService({
				productPlu: a.productPlu,
				servicePlu: parseInt(a.plu),
				details: 'services_details',
				quantity: a.quantity
			});
			focusParams.type = 'basket-services-modal-add';
			$.ajax({
				url: '/cart-item-operation.ltr',
				type: 'POST',
				data: {
					mainCartItemId: a.mainItemId,
					action: 'ADD_PRODUCT_SERVICE',
					addedFrom: 'CART_EDIT',
					serviceId: a.id,
					serviceQuantity: a.quantity
				},
				cache: false,
				success: function () {
					run();
				},
				error: function () {
					modal.alert('Błąd dodawania usługi. Prosimy spróbować później', function () {
						broker.trigger('REFRESH_BASKET_VIEW');
					});
				}
			});
		}
		function getServicesToRemoveForNextProduct(servicesToRemove) {
			// zwraca tablicę obiektów, gdzie każdy obiekt zawiera produkt główny 'mainItemId' i tablicę usług 'servicesIds' do usunięcia dla tego produktu
			return Object.values(servicesToRemove.reduce((acc, item) => {
				if (!acc[item.mainItemId]) {
					acc[item.mainItemId] = {
						mainItemId: item.mainItemId,
						servicesIds: []
					};
				}
				acc[item.mainItemId].servicesIds.push(item.id);
				return acc;
			}, {}));
		}
		function removeSelected() {
			removed.forEach(element => {
				basketAnalytics.removeService({
					productPlu: element.productPlu,
					servicePlu: element.plu,
					quantity: element.quantity
				});
			});
			focusParams.type = 'basket-services-modal-remove';

			var removeRequests = getServicesToRemoveForNextProduct(removed);
			function removeServicesForNextProduct() {
				var request = removeRequests.shift();
				if (!request) {
					removed = [];
					run();
					return;
				}

				update('remove', {
					mainItemId: request.mainItemId,
					servicesIds: request.servicesIds,
					noReload: true,
					addedFrom: 'CART_EDIT'
				}, function () {
					removeServicesForNextProduct();
				});
			}
			removeServicesForNextProduct();
		}
		function removeAdditional() {
			additionalToRemove.forEach(element => {
				basketAnalytics.removeService({
					productPlu: element.productPlu,
					servicePlu: element.plu,
					quantity: element.quantity
				});
			});

			var removeRequests = getServicesToRemoveForNextProduct(additionalToRemove);
			function removeServicesForNextProduct() {
				var request = removeRequests.shift();
				if (!request) {
					additionalToRemove = [];
					run();
					return;
				}

				update('remove', {
					mainItemId: request.mainItemId,
					servicesIds: request.servicesIds,
					noReload: true,
					addedFrom: 'CART_EDIT'
				}, function () {
					removeServicesForNextProduct();
				});
			}
			removeServicesForNextProduct();
		}
		function updateSelected() {
			var t = updated.shift();
			basketAnalytics.updateService(t.productPlu, t.plu, t.quantity / 1);
			focusParams.type = 'basket-services-modal-update';
			update('change', {
				mainItemId: t.mainItemId,
				serviceId: t.id,
				quantity: t.quantity,
				noReload: true,
				addedFrom: 'CART_EDIT'
			}, function () {
				run();
			});
		}
		function run() {
			if (removed.length) {
				removeSelected();
			} else if (additionalToRemove.length) {
				removeAdditional();
			} else if (updated.length) {
				updateSelected();
			} else if (added.length) {
				addSelected();
			} else {
				endSelected();
			}
		}
		run();
	}
	function addedQuantity(value, mainItemId) {
		var addedQuantity = savedAdded.added.filter((e) => {
			return e.id == value && e.mainItemId == mainItemId;
		})
		return addedQuantity.length ? addedQuantity[0].quantity : 0;
	}
	function setModalServicesInitialStateOnOpen($inputs) {
		modalServicesInitialStateOnOpen = [];
		modalServicesInitialStateOnOpen = $inputs.map((_, el) => {
			$input = $(el);
			$service = $(el).closest('.js-service-item');
			return {
				service: $service.data('service'),
				product: $service.data('product'),
				status: $service.data('status'),
				newStatus: $service.data('status'),
				quantity: $input.data('quantity') / 1,
				newQuantity: $input.data('quantity') / 1
			};
		}).get();
		console.log('modalServicesInitialStateOnOpen', modalServicesInitialStateOnOpen);
	}
	function setModalServiceStateChange(params) {
		const { service, product, newStatus, newQuantity } = params;
		if (!service || !product || !modalServicesInitialStateOnOpen || !modalServicesInitialStateOnOpen.length) {
			return;
		}
		const currentService = modalServicesInitialStateOnOpen.find(s => s.service === service && s.product === product);

		if (currentService) {
			currentService.newStatus = newStatus !== undefined ? newStatus : currentService.newStatus;
			currentService.newQuantity = newQuantity !== undefined ? newQuantity : currentService.newQuantity;
		}
	}
	function isAnyModalServiceChanged() {
		if (!modalServicesInitialStateOnOpen || !modalServicesInitialStateOnOpen.length) {
			return;
		}
		return modalServicesInitialStateOnOpen.some(s => s.status !== s.newStatus || s.quantity !== s.newQuantity);
	}

	function open(params) {
		savedAdded = params;
		var content = $('#basket-service-' + params.version + '-' + params.groupId + '-' + (params.packageIdentifier ? params.packageIdentifier : params.mainItemId) + '-' + params.index).html();
		$modal = modal.generate({
			overwrite: true,
			id: 'modal-basket-service',
			content: content,
			modifier: html.has('new-services') ? 'new-services-list remodal-right' : 'services-list remodal-full-width',
			callbackOpen: function () {
				$('#modal-basket-service .js-service-change-more').on('click', function (event) {
					$(this).closest('.service-item').toggleClass('extended');
					event.stopPropagation();
					event.preventDefault();
				}).on('keyup keypress keydown', function (event) {
					event.stopPropagation();
				});
				$inputs = $('#modal-basket-service input:checkbox');
				setModalServicesInitialStateOnOpen($inputs);
				if (!html.has('new-services')) {
					$confirm = $('#modal-basket-service .js-service-change-confirm');
					$inputsAndSelects = $('#modal-basket-service').find('.js-service-quantity, input:checkbox');
					$inputsAndSelects.change((el) => {
						$confirm.removeAttr('disabled');
						updateExcludedServices.run({
							$input: $(el.target),
							$inputs: $inputs
						});
					});
				}
				if (html.has('new-services')) {
					addedServicesWithExclusion = basketServicesWithExclusion.getAddedServicesWithExclusion();
				}
			}
		});
	}
	return {
		change,
		open,
		save,
		increase,
		decrease,
		count,
		info,
		remove,
		add,
		removeFromModal,
		isAnyModalServiceChanged,
		setModalServiceStateChange
	};
});
